import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ChipTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  span {
    display: flex;
    gap: 0;

    ${theme.typography.labelRegular}
  }
`;

export const Star = styled.span`
  font-size: 1.1rem;
`;

export const ChipCount = styled.span`
  display: flex;
  align-items: center;
  color: ${theme.color.text.tertiary};
`;
